import { render } from "./index.vue?vue&type=template&id=48aea97f&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=48aea97f&lang=less&scoped=true"

import exportComponent from "/jenkins/workspace/www.soyoung.com-vue3-pc-master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48aea97f"]])

export default __exports__